import React from 'react';
import '../Routes.css';

function MyPayments() {
  return (
    <div className="page__container">
      <h1 className="page__heading">My Payments</h1>
    </div>
  );
}

export default MyPayments;
